/** Sync status pill: "Last synced X minutes ago · Refresh".
 *  `syncedAt` is an ISO string from the dashboard endpoint; `cacheTtlSeconds`
 *  is the upper bound after which the cache is auto-expired.
 */
import { useEffect, useState } from "react";
import { ArrowsClockwise } from "@phosphor-icons/react";

function formatAge(s) {
  if (s < 5) return "just now";
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) {
    const m = Math.floor(s / 60);
    return `${m} ${m === 1 ? "minute" : "minutes"} ago`;
  }
  const h = Math.floor(s / 3600);
  return `${h} ${h === 1 ? "hour" : "hours"} ago`;
}

export default function SyncStatus({ syncedAt, cacheTtlSeconds = 600, onRefresh, refreshing }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 10_000);
    return () => clearInterval(id);
  }, []);

  const ageSec = syncedAt ? (Date.now() - new Date(syncedAt).getTime()) / 1000 : null;
  const fresh = ageSec === null ? true : ageSec < cacheTtlSeconds * 0.8;
  const label = syncedAt ? `Last synced ${formatAge(ageSec)}` : "Live · streaming";

  return (
    <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.08em] sm:tracking-[0.15em] whitespace-nowrap" data-testid="sync-status">
      <span
        className={`inline-block w-1.5 h-1.5 rounded-full ${fresh ? "bg-emerald-500" : "bg-amber-500"}`}
      />
      <span className="text-[#475569]" data-testid="sync-status-label">{label}</span>
      <button
        onClick={onRefresh}
        disabled={refreshing}
        data-testid="sync-refresh-btn"
        className="flex items-center gap-1 text-[#0F172A] hover:text-[#000] hover:underline disabled:opacity-50"
      >
        <ArrowsClockwise size={11} className={refreshing ? "animate-spin" : ""} />
        {refreshing ? "Refreshing" : "Refresh"}
      </button>
    </div>
  );
}
